import { render } from "./index.vue?vue&type=template&id=2fb663ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2fb663ea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb663ea"]])

export default __exports__